import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#461d7c',
    },
    secondary: {
      main: '#002b49',
    },
  },
});

export default theme;
